module.exports = [
  {
    name: "Development Charter",
    description:
      "Development charter	Charter	Curated feed of learning content based on your talent strengths and development priorities.",
    icon: require("../images/icons/widget/development-charter.svg"),
    id: "DEVELOPMENT_CHARTER",
    action: "developmentCharter",
  },
  {
    name: "Talent Card",
    description:
      "A showcase of your skills and personalities in an infographic format.",
    icon: require("../images/icons/widget/talent-card.svg"),
    id: "TALENT_CARD",
  },
  {
    name: "Profile Card",
    description:
      "Your talent profile that gives a snapshot of your skill strengths and current development focus.",
    icon: require("../images/icons/widget/profile-card.svg"),
    id: "PROFILE_CARD",
  },
  {
    name: "Wallet",
    description:
      "Earn Learning Experience and manage Knowledge transactions in your wallet.",
    icon: require("../images/icons/widget/user-wallet.svg"),
    id: "USER_WALLET",
    action: "userWallet",
  },
  // {
  //   name: "My Activity",
  //   description:
  //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sed tellus id nulla tincidunt faucibus. Aliquam auctor.",
  //   icon: require("../images/icons/widget/development-charter.svg"),
  //   action: "myActivity",
  // },
  {
    name: "Queue Card",
    description:
      "Queue your list of learning materials to follow it later and archive it when you done.",
    icon: require("../images/icons/widget/activity-queue.svg"),
    id: "ACTIVITY_QUEUE",
    action: "talentCard",
  },
  {
    name: "Quest Card",
    description:
      "Commit to enhancing skills by creating development plans with guidance of coach and feedbacks from advisors.",
    icon: require("../images/icons/widget/active-quest.svg"),
    id: "ACTIVE_QUEST",
    action: "activityQuest",
  },
];
